/* eslint-disable import/no-cycle */
import app from '$$app';
import profileModel from '../../models/profile';
import ssoModel from '../../models/sso';
import webhooksModel from '../../models/settings/webhooks';
import TwoFaPopup from './twoFaStore';
import globalToast from '$$vueCmp/toast';

const profileSettingsStore = {
  namespaced: true,
  modules: {
    twoFaPopup: TwoFaPopup,
  },
  state: {},
  getters: {},
  mutations: {},
  actions: {
    onSettingsScroll({}) {
      app.trigger('onSettingsScroll');
      app.trigger('webix:onScroll');
    },
    async sendUpdateOnServer({ dispatch }, data) {
      try {
        await profileModel.updateProfile(data);
        await dispatch('resourcesModel/reloadData', null, { root: true });
        await app.trigger('userProfile:update');
        if (data.firstName || data.lastName || data.photo) {
          app.trigger('userCustomColumnsModel:change'); // update name in dropdown select for resource custom column
        }
        globalToast.success(__('profile_saved'));

        if (data.locale) {
          location.reload();
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },
    addDomainSso({ }, value) {
      const domain = ssoModel.addDomain(value);

      if (domain === 0) {
        webix.message({
          type: 'error',
          text: __('sso_error_text_when_domain_repeated'),
          expire: 10000,
        });

        return;
      }
      if (!domain) {
        return false;
      }
    },
    sendToServerToUpdateSSO({ }, data) {
      ssoModel.update(data);
    },
    sendToWebhooksModel({ }, value) {
      return webhooksModel.create(value);
    },

  },
};

export default profileSettingsStore;
